import styles from "../../../containers/Orders/order-styles.module.css";
import {
	SaveDraftNoOrdersHeader,
	SaveDraftNoOrdersSubheader,
	SaveDraftNoQuotesHeader,
	SaveDraftNoQuotesSubheader,
	SaveDraftNoTemplatesHeader,
	SaveDraftNoTemplatesSubheader
} from "../constants";
import { DraftType, DraftTypeType } from "types/declarations/enums.ts";

interface SaveDraftNoDraftsProps {
	draftType: DraftTypeType;
}

const SaveDraftNoDrafts = ({ draftType }: SaveDraftNoDraftsProps) => {
	const isTemplate = draftType === DraftType.Template;
	const isQuote = draftType === DraftType.Quote;
	const header = () => {
		if (isTemplate) {
			return SaveDraftNoTemplatesHeader;
		}
		if (isQuote) {
			return SaveDraftNoQuotesHeader;
		}
		return SaveDraftNoOrdersHeader;
	};

	const subheader = () => {
		if (isTemplate) {
			return SaveDraftNoTemplatesSubheader;
		}
		if (isQuote) {
			return SaveDraftNoQuotesSubheader;
		}

		return SaveDraftNoOrdersSubheader;
	};

	return (
		<div className={styles.noOrdersErrorBannerContainer}>
			<div>
				<img
					src="/assets/NoOrdersSadBoxImage.svg"
					alt="No Save Draft Orders banner"
					className={styles.noOrdersErrorBannerContainerImage}
					data-testid="no-save-draft-orders-icon"
				/>
				<h5 data-testid="no-save-draft-orders-header">{header()}</h5>
				<p data-testid="no-save-draft-orders-subheader">{subheader()}</p>
			</div>
		</div>
	);
};

export default SaveDraftNoDrafts;
